import React, { useEffect, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography, Box, IconButton, Stack } from "@mui/material";
import _ from "lodash";
import Div from "@jumbo/shared/Div";

import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';

const ImageViewer = props => {
    const [currentImagePos, setCurrentImagePos] = useState(0)

    // El visor se monta una sola vez y solo cambia su prop `isOpen`, asi que la posicion
    // sobrevivia entre aperturas: mirabas la 3a foto de un registro, abrias otro que tenia una
    // sola y se veia "Sin vista previa". Se reposiciona en cada apertura, en la imagen que
    // pidieron (`startAt`) o en la primera.
    useEffect(() => {
        if (props.isOpen) setCurrentImagePos(props.startAt || 0);
    }, [props.isOpen, props.startAt]);

    return (
        <React.Fragment>
            <Dialog
                fullWidth={true}
                maxWidth={"lg"}
                open={props.isOpen}
                onClose={props.onClose}>
                <DialogTitle>
                    <Stack direction="row" justifyContent="space-between">
                        <Typography variant={"h2"} color="primary">{props.title || 'Imágenes'}</Typography>
                        { props.images ? 
                            <Typography>{currentImagePos + 1}/{props.images.length}</Typography> : null
                        }
                    </Stack>
                </DialogTitle>
                <DialogContent>
                    <Stack
                        direction="row" justifyContent="space-between"
                        sx={{
                            height: '70vh',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        }}>
                        <IconButton onClick={() => { setCurrentImagePos(_.max([currentImagePos - 1, 0])) }}>
                            <ArrowCircleLeftIcon color="primary" sx={{ fontSize: 50 }} />
                        </IconButton>
                        { (props.images && currentImagePos < props.images.length) ?
                            <Div>
                                <Box
                                    component="img"
                                    sx={{
                                        maxHeight: '70vh',
                                        maxWidth: '100%',
                                        textAlign: 'center'
                                    }}
                                    // ActiveStorage sirve los SVG como descarga y un <img> con esa URL no
                                    // muestra nada. La toma de conocimiento queda en SVG cuando el
                                    // servidor no tiene libvips: para esas se usa el base64.
                                    src={props.images[currentImagePos]?.content_type === 'image/svg+xml' && props.images[currentImagePos]?.base64
                                        ? props.images[currentImagePos].base64
                                        : props.images[currentImagePos]?.url}
                                />
                                {props.images[currentImagePos]?.caption &&
                                    <Typography variant="body2" color="text.secondary" sx={{ mt: 1, textAlign: 'center' }}>
                                        {props.images[currentImagePos].caption}
                                    </Typography>
                                }
                            </Div>
                        : 'Sin vista previa'
                        }
                        <IconButton onClick={() => { setCurrentImagePos(_.min([currentImagePos + 1, props.images.length - 1])) }}>
                            <ArrowCircleRightIcon color="primary" sx={{ fontSize: 50 }} />
                        </IconButton>
                    </Stack>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => { props.onClose() } }>Cerrar</Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    )
}

export default ImageViewer;